// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?v=" + {"dashboard":"98e972c6b528d84d","upload":"6d86105a0cb55159","login":"a74f282812358b41","register":"bff8ef055f08fc89","forgotPwd":"f7702735ff19f55b","resetPwd":"80bde066f4708ad7","code":"59302d6dd07447b8"}[chunkId] + "";
};